module.exports = __webpack_public_path__ + "img/local-16.a45d0dab.jpg";